module.exports = __webpack_public_path__ + "img/19.837ad5b6.gif";